
export default {
  getViolationBill: '/v3/serveScore/new/violationBill'
}
